import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { CommonService } from '../../api/services';
import { AuthService } from '../../services/auth.service';

export const RolesGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const router = inject(Router);
  const common = inject(CommonService);
  const auth = inject(AuthService);

  if (auth.appRoles.length === 0) {
    return common.commonControllerFindRoles().pipe(
      map((response) => {
        auth.appRoles = response.data.roles;
        return true;
      }),
      catchError((error) => {
        console.error(error);
        return of(false);
      }),
    );
  } else {
    return true;
  }
};

export const RolesGuardCanActivate: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const auth = inject(AuthService);
  return (route.data['roles'] as Array<any>).some((r) => auth.appRoles.map((x) => x.name).includes(r));
};
